/* DetailPanel — right-hand column.
   No selection -> national province ranking.
   Province selected -> summary + per-city (district) bars, expandable customer
   lists, and a top-customers ranking. Adapted to real data via props. */
import React, { useState } from 'react';
import { fmtKip, fmtFull } from './salesGeoHelpers';

function Bar(props) {
    const pct = Math.max(2, Math.round((props.value / (props.max || 1)) * 100));
    return React.createElement(
        'div',
        { className: 'bar-track' },
        React.createElement('div', { className: 'bar-fill', style: { width: pct + '%', background: props.color } })
    );
}

function NationalView(props) {
    const provs = props.provinces.slice().sort((a, b) => b.sales - a.sales);
    const max = provs.length ? provs[0].sales : 1;
    return React.createElement(
        'div',
        { className: 'panel-body' },
        React.createElement(
            'div',
            { className: 'panel-head' },
            React.createElement(
                'div',
                null,
                React.createElement('h2', null, 'ລວມຍອດຂາຍຕາມແຂວງ'),
                React.createElement('p', { className: 'sub' }, 'Sales by province · click a province to drill in')
            )
        ),
        React.createElement(
            'div',
            { className: 'rank-list' },
            provs.map((p, i) =>
                React.createElement(
                    'button',
                    { key: p.pr_id, className: 'rank-row', onClick: () => props.onSelect(p.pr_id) },
                    React.createElement('span', { className: 'rank-num' }, i + 1),
                    React.createElement(
                        'span',
                        { className: 'rank-main' },
                        React.createElement('span', { className: 'rank-lao' }, p.lao),
                        React.createElement('span', { className: 'rank-en' }, p.en),
                        React.createElement(Bar, { value: p.sales, max, color: props.accent })
                    ),
                    React.createElement(
                        'span',
                        { className: 'rank-val' },
                        React.createElement('span', { className: 'rv-amt' }, fmtKip(p.sales)),
                        React.createElement('span', { className: 'rv-cust' }, p.customerCount + ' ລູກຄ້າ')
                    )
                )
            )
        )
    );
}

function DistrictRow(props) {
    const d = props.district;
    const [open, setOpen] = useState(props.defaultOpen);
    return React.createElement(
        'div',
        { className: 'dist' + (open ? ' open' : '') },
        React.createElement(
            'button',
            { className: 'dist-head', onClick: () => setOpen(!open) },
            React.createElement('span', { className: 'chev' }, open ? '−' : '+'),
            React.createElement(
                'span',
                { className: 'dist-name' },
                React.createElement('span', { className: 'dist-lao' }, 'ເມືອງ' + d.lao),
                React.createElement('span', { className: 'dist-en' }, d.en)
            ),
            React.createElement('span', { className: 'dist-val' }, fmtKip(d.sales))
        ),
        React.createElement('div', { className: 'dist-bar' }, React.createElement(Bar, { value: d.sales, max: props.max, color: props.accent })),
        open &&
            React.createElement(
                'div',
                { className: 'cust-list' },
                d.customers.map((c) =>
                    React.createElement(
                        'div',
                        { className: 'cust', key: c.id },
                        React.createElement('span', { className: 'cust-id' }, c.id),
                        React.createElement('span', { className: 'cust-name' }, c.name),
                        React.createElement('span', { className: 'cust-val' }, fmtFull(c.sales))
                    )
                )
            )
    );
}

function ProvinceView(props) {
    const p = props.byId[props.id];
    if (!p) return null;
    const maxDist = p.districts.length ? p.districts[0].sales : 1;
    const topCust = [];
    p.districts.forEach((d) => {
        d.customers.forEach((c) => topCust.push({ c, d }));
    });
    topCust.sort((a, b) => b.c.sales - a.c.sales);
    const top5 = topCust.slice(0, 5);
    const maxCust = top5.length ? top5[0].c.sales : 1;

    return React.createElement(
        'div',
        { className: 'panel-body' },
        React.createElement('button', { className: 'back-btn', onClick: props.onBack }, '← ກັບຄືນ · All provinces'),
        React.createElement(
            'div',
            { className: 'prov-summary' },
            React.createElement('h2', null, p.lao),
            React.createElement('p', { className: 'sub' }, 'ແຂວງ ' + p.en),
            React.createElement(
                'div',
                { className: 'stat-row' },
                React.createElement(
                    'div',
                    { className: 'stat' },
                    React.createElement('span', { className: 'stat-v' }, fmtKip(p.sales)),
                    React.createElement('span', { className: 'stat-l' }, 'ລວມຍອດຂາຍ · Total sales')
                ),
                React.createElement(
                    'div',
                    { className: 'stat' },
                    React.createElement('span', { className: 'stat-v' }, p.customerCount),
                    React.createElement('span', { className: 'stat-l' }, 'ລູກຄ້າ · Customers')
                ),
                React.createElement(
                    'div',
                    { className: 'stat' },
                    React.createElement('span', { className: 'stat-v' }, p.districts.length),
                    React.createElement('span', { className: 'stat-l' }, 'ເມືອງ · Cities')
                )
            )
        ),
        React.createElement('div', { className: 'section-label' }, 'ຍອດຂາຍຕາມເມືອງ · Sales by city'),
        p.districts.length
            ? React.createElement(
                  'div',
                  { className: 'dist-list' },
                  p.districts.map((d, i) =>
                      React.createElement(DistrictRow, { key: d.dr_id, district: d, max: maxDist, accent: props.accent, defaultOpen: i === 0 })
                  )
              )
            : React.createElement('p', { className: 'sub' }, 'ບໍ່ມີຂໍ້ມູນການຂາຍ · No sales in this period'),
        top5.length > 0 &&
            React.createElement(
                React.Fragment,
                null,
                React.createElement('div', { className: 'section-label' }, 'ລູກຄ້າສູງສຸດ · Top customers'),
                React.createElement(
                    'div',
                    { className: 'top-list' },
                    top5.map((row, i) => {
                        const pct = Math.max(3, Math.round((row.c.sales / maxCust) * 100));
                        return React.createElement(
                            'div',
                            { className: 'top-row', key: row.c.id },
                            React.createElement('span', { className: 'top-num' }, i + 1),
                            React.createElement(
                                'div',
                                { className: 'top-main' },
                                React.createElement(
                                    'div',
                                    { className: 'top-line' },
                                    React.createElement('span', { className: 'top-name' }, row.c.name),
                                    React.createElement('span', { className: 'top-val' }, fmtFull(row.c.sales))
                                ),
                                React.createElement('div', { className: 'top-meta' }, row.c.id + ' · ' + row.d.en),
                                React.createElement(
                                    'div',
                                    { className: 'top-track' },
                                    React.createElement('div', { className: 'top-bar', style: { width: pct + '%', background: props.accent } })
                                )
                            )
                        );
                    })
                )
            )
    );
}

const DetailPanel = (props) =>
    React.createElement(
        'aside',
        { className: 'panel' },
        props.selectedId
            ? React.createElement(ProvinceView, { id: props.selectedId, byId: props.byId, accent: props.accent, onBack: () => props.onSelect(null) })
            : React.createElement(NationalView, { provinces: props.provinces, accent: props.accent, onSelect: props.onSelect })
    );

export default DetailPanel;
